<template>
    <v-container class="pa-2" fluid grid-list-sm >  
        <div v-if="getShowModalMessageResult">{{processModalResult()}}</div>

        <v-card class="app-page-card shadow-none" v-if="content">
            <v-card-title>
            Groups
            </v-card-title>
            <v-card-text v-if="!content.permissions"> No permissions  </v-card-text>
            <v-card-text v-if="content.permissions"> 
                <v-row >
                    <v-col cols="6">
                        <v-card>
                            <v-card-text>
                                <h3>My teaching groups</h3>
                                <br>
                                <br>
                                <div>
                                    <v-chip v-for="(group, index) in content.teaching_groups" :key="index" close @click:close="Anything(group)">{{group.group_name}}                                        
                                    </v-chip>
                                </div>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card> 
    </v-container>
</template>

<script>
import axios from '../axios-auth.js'
import {mapGetters} from 'vuex'

export default {
    computed: 
        mapGetters([
                    'getShowModalMessageResult'                    
                ])
    ,
    data() {
        return {
            content : null,
            permissions: false,
        }
    },
    mounted() {
        this.initData()
    },
    methods : {
        initData() {
            this.$store.commit('setFeedback', null)    

            // get category list
            axios.get('/get-course-groups/' + this.$route.params.id, this.$store.getters.getAxiosConfig)
                .then(res => {
                    this.content = res.data 
                    
                    if (res.data.message != 'OK') {
                        this.$store.commit('setFeedback', res.data.message)
                    } 
                    const bc = [
                        { text: res.data.category.name, href: '/areas/' + res.data.category.id },//#
                        { text: res.data.area.name, href: '/courses/' + res.data.area.id }, //#                   
                        { text: res.data.course.name, href: '/course_content/' + res.data.course.id }, //#
                        { text: "Teacher quizzes", href: '/teacher_quizzes/' + res.data.course.id }, //#
                    ]
                    this.$store.commit('setBreadCrumbs',bc)                        
                })
                .catch(error => {
                    this.$store.commit('setFeedback', error)
                })
        },
    }
}
</script>
